// English skeleton — populated later. All keys mirror nl.js.
const en = {
  app: {
    name: "JustEasySEO",
    subtitle: "Advisory Mode",
    tagline: "The autonomous AI Marketing & Growth Director for entrepreneurs.",
    ghost_active: "ADVISORY MODE ACTIVE",
    demo_badge: "DEMO",
  },
  nav: {
    command_center: "Overview",
    ceo_dashboard: "CEO Dashboard",
    seo: "SEO",
    social: "Social Suite",
    publish_queue: "Publish Queue",
    integrations: "Integrations",
    site_audit: "Site Audit",
    intake: "Your business",
    privacy_vault: "Data & connections",
    business_brain: "Business Brain",
    ghost_ledger: "Advice & decisions",
    weekly_report: "Weekly report",
    weekplan: "Weekly plan",
    vlogs: "Vlogs",
    wallet: "Marketing budget",
    market_radar: "Market radar",
    connections: "Connections",
    logout: "Log out",
  },
};

export default en;
